/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_Column_RegisteredInputs */

const id_staff_resellers_column_registered = /** @type {(inputs: Staff_Resellers_Column_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendaftar`)
};

const en_staff_resellers_column_registered = /** @type {(inputs: Staff_Resellers_Column_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied`)
};

/**
* | output |
* | --- |
* | "Applied" |
*
* @param {Staff_Resellers_Column_RegisteredInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_column_registered = /** @type {((inputs?: Staff_Resellers_Column_RegisteredInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_Column_RegisteredInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_column_registered(inputs)
	return id_staff_resellers_column_registered(inputs)
});